export enum PAYMENT_REFERENCE {
  MERCADOPAGO = 'mercadopago',
  CREDIT = 'credit',
}
